// Shared UI kit for the RMS Incident Report module (professional light records theme).
export const RT = {
  page: "#dbe2e9", panel: "#ffffff", border: "#b9c5cf", head: "#1d5d90", navy: "#122a42",
  nav: "#16324d", navActive: "#2a628f", text: "#17222c", dim: "#5b6c7a", input: "#f5f8fa",
};

export const STATUS_COLORS = {
  DRAFT: "#b45309", "IN PROGRESS": "#b45309", "PENDING REVIEW": "#b8860b", RETURNED: "#b91c1c",
  APPROVED: "#15803d", "SUPPLEMENT REQUIRED": "#b45309", LOCKED: "#334155", ARCHIVED: "#334155",
};

export const Panel = ({ title, right, children, testid }) => (
  <div data-testid={testid} className="bg-white border rounded-sm overflow-hidden" style={{ borderColor: RT.border }}>
    <div className="flex items-center px-3 py-1.5" style={{ background: RT.head }}>
      <span className="font-head font-bold text-[11px] tracking-wider text-white uppercase">{title}</span>
      <div className="ml-auto">{right}</div>
    </div>
    <div className="p-3">{children}</div>
  </div>
);

export const Lbl = ({ children }) => (
  <div className="font-mono text-[9px] uppercase tracking-wide mb-0.5" style={{ color: RT.dim }}>{children}</div>
);

export const Inp = ({ label, value, onChange, disabled, placeholder, testid, type = "text" }) => (
  <div>
    <Lbl>{label}</Lbl>
    <input data-testid={testid} type={type} value={value ?? ""} disabled={disabled} placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      className="w-full border px-2 py-1 text-[12px] font-mono rounded-sm outline-none focus:border-[#1d5d90] disabled:opacity-60"
      style={{ background: RT.input, borderColor: RT.border, color: RT.text }} />
  </div>
);

export const Sel = ({ label, value, onChange, options, disabled, testid, allowEmpty = true }) => (
  <div>
    <Lbl>{label}</Lbl>
    <select data-testid={testid} value={value ?? ""} disabled={disabled} onChange={(e) => onChange(e.target.value)}
      className="w-full border px-1.5 py-1 text-[12px] font-mono rounded-sm outline-none disabled:opacity-60"
      style={{ background: RT.input, borderColor: RT.border, color: RT.text }}>
      {allowEmpty && <option value="">—</option>}
      {options.map((o) => <option key={o} value={o}>{o}</option>)}
    </select>
  </div>
);

export const YN = ({ label, value, onChange, disabled, testid, unknown = false }) => (
  <Sel label={label} value={value} onChange={onChange} disabled={disabled} testid={testid}
    options={unknown ? ["YES", "NO", "UNKNOWN"] : ["YES", "NO"]} allowEmpty={false} />
);

export const Btn = ({ children, onClick, color = RT.head, disabled, testid, small }) => (
  <button data-testid={testid} onClick={onClick} disabled={disabled}
    className={`inline-flex items-center gap-1.5 ${small ? "px-2 py-1 text-[10px]" : "px-3 py-1.5 text-[11px]"} font-head font-bold uppercase text-white rounded-sm disabled:opacity-50`}
    style={{ background: color }}>{children}</button>
);

export const Th = ({ children }) => (
  <th className="text-left px-2 py-1 font-mono text-[9px] uppercase tracking-wider border-b"
    style={{ color: RT.dim, borderColor: RT.border }}>{children}</th>
);
export const Td = ({ children, mono = true }) => (
  <td className={`px-2 py-1.5 text-[11.5px] ${mono ? "font-mono" : ""} border-b`}
    style={{ color: RT.text, borderColor: "#e3e9ee" }}>{children}</td>
);
